import { useEffect, useRef } from 'react';
import pdfjsLib from './pdfWorkerLoader';

export const PDFViewer = ({ file, scale = 1.5 }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!file || !containerRef.current) return;

    let isCancelled = false;

    const loadPDF = async () => {
      try {
        const container = containerRef.current;
        container.innerHTML = ''; // Clear previous renders

        const response = await fetch(file);
        const buffer = await response.arrayBuffer();

        const loadingTask = pdfjsLib.getDocument({
          data: buffer,
          verbosity: 0,
        });

        const pdf = await loadingTask.promise;

        const renderPage = async (pageNum) => {
          if (isCancelled) return;

          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          container.appendChild(canvas);

          await page.render({
            canvasContext: context,
            viewport,
          }).promise;
        };

        // Render all pages in parallel for faster load
        await Promise.all(
          Array.from({ length: pdf.numPages }, (_, i) => renderPage(i + 1))
        );
      } catch (err) {
        console.error('PDF render failed:', err);
      }
    };

    loadPDF();

    return () => {
      isCancelled = true;
    };
  }, [file, scale]);

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
      }}
    />
  );
};
